import React from 'react';
import { GradientTextAction, Poppins } from 'src/common';
import Loader from 'src/components/Loader/Loader';
import { InvitedUserRoles, Role, useInviteRolesLazyQuery } from 'src/graphql/_generated';
import styled from 'styled-components';

const Div = styled.div`
  height: 53px;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.aliceBlue};
  display: flex;
  align-items: center;
  padding: 0 14px;
  justify-content: space-between;
`;

interface AvailableRolesProps {
  email: string;
  workspaceId?: string;
  organisationId?: string;
  onAvailableRoles: (roles: InvitedUserRoles | undefined) => void;
}

export const AvailableRoles: React.FC<AvailableRolesProps> = ({
  onAvailableRoles,
  email,
  workspaceId,
  organisationId,
}) => {
  const [inviteRoles, { loading }] = useInviteRolesLazyQuery();

  return (
    <Div>
      {!loading ? (
        <>
          <Poppins weight={500} px={14}>
            Once you’ve entered the email address,{' '}
            <GradientTextAction
              $underline
              weight={500}
              px={14}
              onClick={() => {
                inviteRoles({ variables: { workspaceId, organisationId, userEmail: email } }).then(({ data }) => {
                  onAvailableRoles(data?.inviteRoles);
                });
              }}
            >
              check for available roles
            </GradientTextAction>
            .
          </Poppins>
        </>
      ) : (
        <>
          <Poppins px={14} weight={500} color="cflowerBlue">
            <i>Checking user for available roles ...</i>
          </Poppins>
          <div>
            <Loader size="small" />
          </div>
        </>
      )}
    </Div>
  );
};
